var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 152,
    viewBox: "0 0 260 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_35368)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.333,
    height: 152,
    transform: "translate(0.333252)",
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-283.167 -103.937C-283.167 -110.283 -278 -115.432 -271.622 -115.432H-271.622L156.028 -115.5C159.96 -115.5 163.697 -113.801 166.272 -110.846L187.923 -85.987C190.373 -83.1723 191.724 -79.5751 191.727 -75.852L191.833 35.0699C191.837 39.2428 190.343 43.2804 187.619 46.4527L166.744 70.7719L167.123 71.0975L166.744 70.7719C164.169 73.7719 160.402 75.5 156.439 75.5H-271.62C-277.999 75.5 -283.167 70.351 -283.167 64.0049V-103.937Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-763.167 60.6287C-763.167 47.3824 -752.382 36.6387 -739.071 36.6387L-739.071 36.6387L134.198 36.5C142.377 36.5 150.152 40.0333 155.509 46.1807L199.721 96.9346C204.805 102.776 207.61 110.241 207.617 117.968L207.833 344.434C207.841 353.078 204.745 361.442 199.103 368.014L156.475 417.665C151.118 423.906 143.281 427.5 135.038 427.5H-739.067C-752.378 427.5 -763.167 416.756 -763.167 403.51V60.6287Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253.667 97.4242C-253.667 92.2491 -249.453 88.0531 -244.254 88.0531L89.9604 88C93.1459 88 96.1741 89.3759 98.2608 91.77L115.182 111.191C117.157 113.461 118.248 116.362 118.25 119.365L118.333 206.023C118.336 209.377 117.135 212.621 114.946 215.171L98.6313 234.17C96.5446 236.6 93.4925 238 90.2818 238H-244.252C-249.451 238 -253.667 233.804 -253.667 228.629V97.4242Z",
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.333 -72.2564C209.333 -78.1561 214.136 -82.9395 220.062 -82.9395L600.994 -83C604.625 -83 608.077 -81.4315 610.455 -78.7022L629.741 -56.5621C631.993 -53.9745 633.236 -50.6672 633.239 -47.2436L633.333 51.5462C633.336 55.3694 631.967 59.0685 629.472 61.9745L610.877 83.6338C608.499 86.4044 605.02 88 601.361 88H220.064C214.138 88 209.333 83.2166 209.333 77.3169V-72.2564Z",
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.3333,
    cy: 36,
    r: 17,
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_35368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.333,
    y: 51,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.889 75.5833L127.555 80.4444V70.7222L135.889 75.5833Z",
    fill: "#FF6C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_35368",
    x: 101.333,
    y: 49,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_35368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_35368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_35368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.333,
    height: 152,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDefault);
export default __webpack_public_path__ + "static/media/video-default.011975f6e30033f004fd73a7372d9706.svg";
export { ForwardRef as ReactComponent };